// Hacıoğlu Ürün Eşleştirme sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'ecommerce.haciogluMapping';

export const ecommerceHaciogluMappingGuide = (t: TFunction): GuideContent => ({
  layout: 'tabbed',
  title: t(`${G}.title`, 'Hacıoğlu ürün eşleştirme nasıl yapılır?'),
  intro: t(`${G}.intro`, 'GTS stok kartlarınızı Hacıoğlu sistemindeki ürünlerle eşleştirirsiniz. Siparişler Hacıoğlu sistemine aktarılırken ürünler bu eşleştirmeye göre bulunur; yanlış eşleşme siparişin yanlış ürünle aktarılmasına yol açar. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  navItems: [
    t(`${G}.nav.create`, 'Create Mapping'),
    t(`${G}.nav.existing`, 'Existing Mappings'),
    t(`${G}.nav.products`, 'Product Management'),
  ],
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık ve Smart Suggestion'),
    tabs: t(`${G}.regions.tabs`, 'Sekmeler'),
    body: t(`${G}.regions.body`, 'Ürün listeleri'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Eşleştirme oluşturun'),
      text: t(`${G}.s1.text`, '"Create Mapping" sekmesinde solda GTS ürünleriniz (GTS Products), sağda Hacıoğlu ürünleri (Hacioglu Products) listelenir. Her iki listeden birer ürün seçin; seçimler ortada görünür. Ardından "Match" düğmesine basın.'),
      tips: [
        t(`${G}.s1.tip1`, 'Soldaki listede "All / Unmatched / Matched" düğmeleriyle tüm, eşleşmemiş veya eşleşmiş ürünleri gösterin. Eşleşmiş ürünlerde yeşil ✓ işareti görünür.'),
        t(`${G}.s1.tip2`, '"Search product..." kutularıyla iki listede ayrı ayrı arama yapın.'),
        t(`${G}.s1.tip3`, 'Bir GTS ürünü yalnız bir Hacıoğlu ürünüyle eşleşir; zaten eşleşmiş ürün yeniden eşleştirilemez. Değiştirmek için önce eski eşleşmeyi kaldırın.'),
      ],
    },
    {
      region: 'header',
      title: t(`${G}.s2.title`, '2. Akıllı önerileri kullanın'),
      text: t(`${G}.s2.text`, '"Smart Suggestion" düğmesi, ürün adları birbirine benzeyen (en az %50 benzerlik) GTS ve Hacıoğlu ürünlerini en fazla 20 öneri olarak listeler. Benzerlik oranı %90 ve üstü yeşil, %70 ve üstü turuncu gösterilir. Doğru olan öneride "Apply" düğmesine basın.'),
      tips: [
        t(`${G}.s2.tip1`, 'Öneri yalnız ad benzerliğine dayanır; uygulamadan önce ürünün gerçekten aynı olduğundan emin olun.'),
      ],
    },
    {
      region: 'tabs',
      title: t(`${G}.s3.title`, '3. Mevcut eşleşmeleri kontrol edin'),
      text: t(`${G}.s3.text`, '"Existing Mappings" sekmesi tüm eşleşmeleri ve sayısını gösterir. Yanlış bir eşleşmeyi kaldırmak için satırdaki "Remove Mapping" simgesine basın ve "Remove" ile onaylayın; ürün yeniden eşleştirilebilir hale gelir.'),
    },
    {
      region: 'tabs',
      title: t(`${G}.s4.title`, '4. Hacıoğlu ürün listesini yönetin'),
      text: t(`${G}.s4.text`, '"Product Management" sekmesinde Hacıoğlu ürün listesine yeni ürün ekler (Stock Code ve Product Name zorunlu; Product Group ve Price isteğe bağlı), mevcut ürünü düzenler veya pasif yaparsınız. Pasif yapmadan önce onay sorulur.'),
      tips: [
        t(`${G}.s4.tip1`, 'Arama kutusu ürün adı, stok kodu veya ürün grubuna göre arar.'),
        t(`${G}.s4.tip2`, 'Başlıktaki (i) bu rehberi yeniden açar.'),
      ],
    },
  ],
});
